import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw_flex_center" }
const _hoisted_2 = { class: "m-4" }
const _hoisted_3 = { class: "m-4" }
const _hoisted_4 = { class: "flex justify-end" }

import { ref, onMounted } from "vue";
import moment from "moment";
// import HelloWorld from '@/components/HelloWorld.vue' // @ is an alias to /src
// import MyProgress from "@/components/MyProgress.vue";
// import { easeOut, progress } from "motion-v/es";
// import { Icon } from "@iconify/vue";
// import { motion } from "motion-v";
// import { read_todo } from "@/helper";
// import LoadingIcon from "@/components/LoadingIcon.vue";
// import TodoChart from "@/components/TodoChart.vue";
import im2 from "@/components/Img2.vue";

// const url = "https://api-get-todos-baqco6xtzq-uc.a.run.app";
// const loaded = ref(false);
// const todo = ref(0);
// const doing = ref(0);
// const done = ref(0);
// const skip = ref(0);
// const reject = ref(0);
// const unknown = ref(0);
// const is_show_progress = ref(false);

// function get_precent() {
//   let total = todo.value;
//   // total += doing.value;
//   total += done.value;
//   // total += skip.value;
//   // total += reject.value;
//   if (total == 0) return 0;
//   if (total == Number.NaN) return 0;

//   let complete = done.value;
//   // complete += skip.value;

//   let precent = complete / total;
//   // console.log("get_precent", complete, total, precent);

//   return precent;
// }

// function get_precent_text() {
//   var v = get_precent();
//   v = Math.round(v * 100);
//   return `${v}%`;
// }

interface APP_DATA {
  name: string;
  ver: number;
  date: string;
  to: string;
  icon: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

// src\views\HomeView.vue
const raw_list: APP_DATA[] = [
  //
  {
    name: "V Puzzle Girls",
    ver: 28,
    date: "2026-01-24",
    to: "/jsmg",
    icon: "/jsmg/app_icon_2.jpg",
  },
  {
    name: "Block Blast Girls",
    ver: 52,
    date: "2026-02-20",
    to: "/bbg",
    icon: "/bbg/app_icon.jpg",
  },
  {
    name: "Jigsaw Anime Girl",
    ver: 29,
    date: "2026-03-20",
    to: "/jag",
    icon: "/jag/app_icon_2.jpg",
  },
  {
    name: "Jewel Master Girl",
    ver: 53,
    date: "2026-03-09",
    to: "/jmg",
    icon: "/jmg/app_icon.jpg",
  },
  {
    name: "Match3 Master Girl",
    ver: 25,
    date: "2026-04-20",
    to: "/mg",
    icon: "/mmg/mmg_loop_quad_gif.webp",
  },
];
const app_list = ref<APP_DATA[]>([]);

onMounted(async () => {
  //
  document.title = "NadoProject";

  raw_list.sort((a, b) => {
    if (a.date == b.date) return 0;
    if (a.date > b.date) return -1;
    return 1;
  });

  for (var data of raw_list) {
    app_list.value.push(data);
  }

  // try {
  //   const res = await Helper.web_get(url);
  //   console.log("res", res.data);

  //   loaded.value = true;

  //   const data = read_todo(res.data);
  //   todo.value = data.todo;
  //   done.value = data.done;

  //   // 남은거 검사
  //   for (var k in res.data) {
  //     if (k == "key") continue;
  //     if (k == "date") continue;
  //     if (k == "diff") continue;
  //     unknown.value++;
  //   }

  //   if (unknown.value > 0) {
  //     console.error("not proc item", res.data);
  //   }
  // } catch (err) {
  //   const e = err as Error;
  //   console.log("catch", e.message);
  // }
});

// export default defineComponent({
//   name: 'HomeView',
//   components: {
//     HelloWorld
//   }
// })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Game List", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", null, "sorted", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(app_list.value, (date) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "mt-8",
        key: date.to
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            to: date.to
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(im2, {
                  class: "rounded-3xl w-64",
                  src: date.icon
                }, null, 8, ["src"])
              ]),
              _createElementVNode("h1", _hoisted_3, _toDisplayString(date.name), 1),
              _createElementVNode("div", _hoisted_4, " v" + _toDisplayString(date.ver) + " - " + _toDisplayString(_unref(moment)(date.date).fromNow()), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ])
      ]))
    }), 128))
  ]))
}
}

})